<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">{{displayTitle}}</legend>
    </div>
    <div class="grid-col flex-auto margin-left-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
            data-tooltip="Click for more options">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a (click)="createEdit('create', createModal)">Create User</a>
            </li>
            @if (this.isAgencyUser && !this.isFromUserProfile) {
              <li class="usa-nav__submenu-item">
                <a (click)="goToAgencyProfile()">General Info</a>
              </li>
            }
            @if (!this.isAgencyUser && !this.isFromUserProfile) {
              <li class="usa-nav__submenu-item">
                <a (click)="goToCarrierProfile()">General Info</a>
              </li>
            }
            @if (this.isFromUserProfile) {
              <li class="usa-nav__submenu-item">
                <a (click)="goToUserProfile()">User Profile</a>
              </li>
            }
            @if (!this.isFromUserProfile) {
              <li class="usa-nav__submenu-item">
                <a (click)="goToAgencyTspSearch()">Search</a>
              </li>
            }
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="grid-row">
    <legend class="usa-legend usa-legend--medium" [innerHTML] = "carrierAgencyDetails"></legend>
  </div>
  <div class="grid-row">
    @if (message) {
      <div class="usa-alert usa-alert--success usa-alert--no-icon" hidden="modal.hide">
        <div class="usa-alert__body">
          <p class="usa-alert__text">
            {{message}}
          </p>
        </div>
      </div>
    }
  </div>
  <ag-grid-angular
    class="ag-theme-alpine margin-top-2"
    [gridOptions]="userListResultsGridOptions"
    [rowData]="agencyUserList"
    [columnDefs]="columnDefs"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
    [suppressDragLeaveHidesColumns]="true"
    ag-grid-resize>
  </ag-grid-angular>
</div>


<!-- Create User Modal -->
<div bsModal #createModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-create-user"
  [config]="{backdrop: 'static'}">
  <div class="usa-modal usa-modal--lg display-flex" id="example-modal-2" aria-labelledby="modal-2-heading" aria-describedby="modal-2-description">
    <div class="usa-modal__content">
      <div class="usa-modal__main padding-y-0 define-width">
        <h2 class="usa-modal__heading" id="modal-2-heading">
          {{title}}
        </h2>
        <div class="usa-prose">
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              @if (message) {
                <div class="alert alert-info">{{message}}</div>
              }
            </div>
          </div>
          <form [formGroup]="agencyUserForm">
            <div class="grid-row grid-gap">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="firstName" class="usa-label">First Name <abbr title="required"
                class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" id="firstName" formControlName="firstName" class="maxw-full usa-input" aria-label="firstName" size='35' maxlength='35'>
                @if (this.agencyUserForm.get('firstName').hasError('required') && (this.agencyUserForm.get('firstName').touched || this.agencyUserForm.get('firstName').dirty)) {
                  <div>
                    <small class="text-danger">
                      <span class="fa fa-warning"></span> First Name is required
                    </small>
                  </div>
                }
                @if (this.agencyUserForm.get('firstName').hasError('pattern')) {
                  <div>
                    <small class="text-danger"> <span class="fa fa-warning"></span>
                    First Name is invalid.
                  </small>
                </div>
              }
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="middleInitial" class="usa-label">Middle Initial</label>
              <input type="text" id="middleInitial" formControlName="middleInitial" aria-label="middleInitial" class="usa-input maxw-full" size='1' maxlength='1'>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="lastName" class="usa-label">Last Name<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="lastName" formControlName="lastName" class="usa-input maxw-full" aria-label="lastName" size='35' maxlength='35'>
              @if (this.agencyUserForm.get('lastName').hasError('required') && (this.agencyUserForm.get('lastName').touched || this.agencyUserForm.get('lastName').dirty)) {
                <div>
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Last Name is required
                  </small>
                </div>
              }
              @if (this.agencyUserForm.get('lastName').hasError('pattern')) {
                <div>
                  <small class="text-danger"> <span class="fa fa-warning"></span>
                  Last Name is invalid.
                </small>
              </div>
            }
          </div>

        </div>

        <div class="grid-row grid-gap">
          @if (!isCreate) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="email" class="usa-label">Email<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input readonly id="email" class="maxw-full usa-input" formControlName="email">
            </div>
          }
          @if (isCreate) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="email" class="usa-label">Email<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="email" required class="usa-input maxw-full" formControlName="email" size='250' maxlength='250'>
              @if (this.agencyUserForm.get('email').invalid && (this.agencyUserForm.get('email').touched || this.agencyUserForm.get('email').dirty) && this.agencyUserForm.get('email').errors.required) {
                <div class="alert">
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Email address is required
                  </small>
                </div>
              }
              @if (this.agencyUserForm.get('email').invalid && (this.agencyUserForm.get('email').touched || this.agencyUserForm.get('email').dirty) && this.agencyUserForm.get('email').errors.email) {
                <div class="alert">
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Email Address is invalid
                  </small>
                </div>
              }
            </div>
          }

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="phone" class="usa-label">Phone<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="phone" class="usa-input maxw-full" formControlName="phone" size='20' minLength='10' maxlength='20' appNumbersOnly>
            @if (this.agencyUserForm.get('phone').invalid && (this.agencyUserForm.get('phone').touched || this.agencyUserForm.get('phone').dirty) && this.agencyUserForm.get('phone').errors.required) {
              <div class="alert">
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone is required
                </small>
              </div>
            }
            @if (this.agencyUserForm.get('phone').invalid &&
              (this.agencyUserForm.get('phone').touched || this.agencyUserForm.get('phone').dirty) && this.agencyUserForm.get('phone').errors.numeric) {
              <div class="alert"
                >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> Phone Number is invalid - should be all numeric, no dashes,
                  no spaces
                </small>
              </div>
            }
            @if (this.agencyUserForm.get('phone').invalid &&
              (this.agencyUserForm.get('phone').touched || this.agencyUserForm.get('phone').dirty)) {
              <div class="alert">
                @if (this.agencyUserForm.get('phone').errors.minlength) {
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Phone Number should be at least 10 digits long
                  </small>
                }
                @if (this.agencyUserForm.get('phone').errors.maxlength) {
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Phone Number should be less than 15 digits long
                  </small>
                }
              </div>
            }
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="phoneExtension" class="usa-label">Phone Extension</label>
            <input type="text" id="phoneExtension" class="usa-input maxw-full" minLength="5" maxlength="5" size="5" formControlName="phoneExtension" appNumbersOnly>
            @if (this.agencyUserForm.get('phoneExtension').invalid && (this.agencyUserForm.get('phoneExtension').touched || this.agencyUserForm.get('phoneExtension').dirty)) {
              <div>
                @if (this.agencyUserForm.get('phoneExtension').errors.numeric) {
                  <div>
                    <small class="text-danger">
                      <span class="fa fa-warning"></span> Phone Extn. is invalid - should be all numeric, no dashes,
                      no spaces
                    </small>
                  </div>
                }
              </div>
            }
          </div>

        </div>

        <div class="grid-row grid-gap">
          @if (isAgencyUser) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="agencyUserRole" class="usa-label">Permissions<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select formControlName='agencyUserRole' id="agencyUserRole" class="usa-select maxw-full">
                <option [ngValue]="null">Select a Permission..</option>
                @for ( role of agencyUserRoles; track  role) {
                  <option>{{role.name}}</option>
                }
              </select>
            </div>
          }

          @if (!isAgencyUser) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="agencyUserRole" class="usa-label">Permissions<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select formControlName='agencyUserRole' id="agencyUserRoleId" class="usa-select maxw-full">
                <option [ngValue]="null">Select a Permission..</option>
                @for ( carrierUserRole of carrierUserRoles; track  carrierUserRole) {
                  <option>{{carrierUserRole.name}}</option>
                }
              </select>
            </div>
          }

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4 hidden" >
            <input type="text" hiddedn="true" id="id" class="maxw-full usa-input" maxlength="8" formControlName="id">
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="mobilePhone" class="usa-label">Mobile</label>
            <input type="text" id="mobilePhone" class="usa-input maxw-full" formControlName="mobilePhone" size='20' minLength='10' maxlength='20' appNumbersOnly>
            @if (this.agencyUserForm.get('mobilePhone').invalid &&
              (this.agencyUserForm.get('mobilePhone').touched || this.agencyUserForm.get('mobilePhone').dirty) && this.agencyUserForm.get('mobilePhone').errors.numeric) {
              <div class="alert"
                >
                <small class="text-danger">
                  <span class="fa fa-warning"></span> mobile Number is invalid - should be all numeric, no dashes,
                  no spaces
                </small>
              </div>
            }
            @if (this.agencyUserForm.get('mobilePhone').invalid &&
              (this.agencyUserForm.get('mobilePhone').touched || this.agencyUserForm.get('mobilePhone').dirty) &&
              this.agencyUserForm.get('mobilePhone').errors.minlength) {
              <div class="alert">
                <small class="text-danger">
                  <span class="fa fa-warning"></span> mobile Number should be at least 10 digits long
                </small>
              </div>
            }
          </div>
        </div>

      </form>
      <div class="grid-row grid-gap padding-105">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          @if (userAlreadyExistsMessage !== '') {
            <small class="text-danger">
              <span class="fa fa-warning">{{userAlreadyExistsMessage}}</span>
            </small>
          }
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <ul class="usa-button-group">
            <li class="usa-button-group__item">
              @if (this.isCreate) {
                <button type="button" class="usa-button" (click)="createUser(createModal)"
                  [disabled]="this.agencyUserForm.invalid">Create
                </button>
              }
            </li>
            <li class="usa-button-group__item">
              @if (!this.isCreate) {
                <button type="button" class="usa-button" (click)="updateUser(createModal)"
                  [disabled]="this.agencyUserForm.invalid || suspenededUser">Save
                </button>
              }
            </li>
            <li class="usa-button-group__item">
              @if (!this.isCreate) {
                <button type="button" class="usa-button" (click)="resetPassword(createModal)"
                  [disabled]="this.agencyUserForm.invalid || disabledResetPassword || reactivateUser">Reset Password
                </button>
              }
            </li>
            <li class="usa-button-group__item">
              @if (!this.isCreate && reactivateUser) {
                <button type="button" class="usa-button" (click)="resetPassword(createModal)"
                  [disabled]="this.agencyUserForm.invalid">Reactivate User
                </button>
              }
            </li>
            <li class="usa-button-group__item">
              @if (!this.isCreate) {
                <button type="button" class="usa-button usa-button--secondary"
                  (click)="deleteUser(createModal)" [disabled]="this.agencyUserForm.invalid || suspenededUser">Delete
                </button>
              }
            </li>
            <li class="usa-button-group__item">
              <button type="button" class="usa-button" (click)="createModal.hide()">Close</button>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
  <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="createModal.hide()" data-close-modal>
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>
</div>
</div>
</div>
